import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import './global-styles.css';
import React, { useState, useEffect, Component } from "react";
import styled from "styled-components";
import Login from "./features/auth/Login";
import AuthCallback from "./features/auth/services/AuthCallback";
import { ThemeProvider, useTheme } from "./middleware/ThemeContext";
import { ToastProvider, useToast } from "./components/toast/ToastContext";
import SidebarMenu from "./components/sidebar/SideBarMenu";
import TopBar from "./components/topBar/TopBar";
import Dashboard from "./features/dashboard/Dashboard";
import { DEFAULT_BASIC_CONFIG } from "./types/types";
import WebsitePreview from "./features/websitePreview/WebsitePreview";
import OrganizationDetails from "./features/organizations/OrganizationDetails/OrganizationDetails";
import { DynamicBrandProvider } from "./branding/DynamicBrandProvider";
import AccountSettings from "./features/accountSettings/AccountSettings";
import ContactDetails from "./features/organizations/ContactDetails/ContactDetails";
import ForceLogin from "./features/auth/ForceLogin";
const App = () => {
  return (
    <ToastProvider>
      <ThemeProvider>
        <DynamicBrandProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/force-login" element={<ForceLogin />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              {/* <Route path="/settings" element={<AccountSettings />} /> */}
              <Route path="/*" element={<WebsitePreview />} />
            </Routes>
          </BrowserRouter>
        </DynamicBrandProvider>
      </ThemeProvider>
    </ToastProvider>
  );
};

export default App;

